export enum ActionTypes {
  LOAD_DEVICE_CONFIGURATION_REQUEST = 'LOAD_DEVICE_CONFIGURATION_REQUEST',
  LOAD_DEVICE_CONFIGURATION_SUCCEDED = 'LOAD_DEVICE_CONFIGURATION_SUCCEDED',
  LOAD_DEVICE_CONFIGURATION_FAILED = 'LOAD_DEVICE_CONFIGURATION_FAILED',

  UPDATE_DEVICE_CONFIGURATION_REQUEST_REQUEST = 'UPDATE_DEVICE_CONFIGURATION_REQUEST_REQUEST',
  UPDATE_DEVICE_CONFIGURATION_REQUEST_SUCCEDED = 'UPDATE_DEVICE_CONFIGURATION_REQUEST_SUCCEDED',
  UPDATE_DEVICE_CONFIGURATION_REQUEST_FAILED = 'UPDATE_DEVICE_CONFIGURATION_REQUEST_FAILED',

  UPDATE_DEVICE_SPEED_REQUEST_REQUEST = 'UPDATE_DEVICE_SPEED_REQUEST_REQUEST',
  UPDATE_DEVICE_SPEED_REQUEST_SUCCEDED = 'UPDATE_DEVICE_SPEED_REQUEST_SUCCEDED',
  UPDATE_DEVICE_SPEED_REQUEST_FAILED = 'UPDATE_DEVICE_SPEED_REQUEST_FAILED',
}
